import React from 'react'
import Footer from "../components/footer/Footer";
import ContactForm from '../components/contact-form/ContactForm';
import Navbar from "../components/navbar/Navbar";
import SecondBanner from '../components/second-banner/SecondBanner';

const Contact = () => {
  return (
    <>
    <Navbar />
    <SecondBanner head={"Contact Me"} text={"Please Fill Out the Email Form Below to Reach Me"}/>
    <ContactForm />
    <Footer />
    </>
  )
}

export default Contact